module.exports = __webpack_public_path__ + "static/img/favicon.fd22ae1.png";